import React from "react";
import { graphql } from "gatsby";
import { Grid } from "semantic-ui-react";
import Helmet from "react-helmet";
import {
  PageLayout,
  CardNavigation,
  HeroElement,
  ImageCollection,
  Reviews,
  Contact
} from "@fishrmn/fishrmn-components";

import Layout from "../components/Layout";

export default class extends React.PureComponent {
  render() {
    const businessData = this.props.data.allFisherman.edges[0].node;
    const imageData = this.props.data.allFishermanImages.edges[0].node;
    const data = { ...businessData, ...imageData };

    return (
      <Layout>
        <Helmet>
          <title>Cristobal Mexican Grill &amp; Bar | Home</title>
          <meta name="description" content=" Cristobal Mexican Grill is family owned and serves delicious, authentic, cheap Mexican food. Come try our burritos, tacos and more!" />
        </Helmet>
        <PageLayout
          hero={
            <HeroElement
              header={"Cristobal Mexican Grill & Bar"}
              tagline={""}
              images={[data.heroImages.map(({ url }) => url)[1]]}
              showMap={false}
              ctas={[data.ctas.orderOnline, data.ctas.phone]}
              ctaInverted={false}
              ctaColor={"secondary"}
              containerColor={"primary"}
              textColor={"white"}
              showMultiple={true}
              overlay={false}
              fullWidth={true}
              parallax={false}
              containerAs={"outline"}
              height={500}
              gutter={false}
            />
          }
        >
          <Grid
            stackable
            className="component-section-container"
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={16}>
              <ImageCollection
                as={"carousel"}
                carouselOptions={{
                  autoScroll: true,
                  autoScrollTime: 4000
                }}
                centered={false}
                cutUnevenRows={true}
                disable={"both"}
                header={"Gallery"}
                images={data.galleryImages.map(({ url }) => url)}
                numberOfRowDisplayItems={4}
              />
            </Grid.Column>
          </Grid>
          <Grid
            stackable
            className="component-section-container"
            verticalAlign={"middle"}
            textAlign={"left"}
          >
            <Grid.Column width={16}>
              <Reviews
                reviews={data.reviews}
                as={"verticalItem"}
                buttonBasic={false}
                buttonSize={"medium"}
                cardInlinePhoto={"left"}
                centerHeader={true}
                header={"Reviews"}
                imageCircular={false}
                imageSize={"small"}
                itemButtonFloat={"left"}
                itemCenterContent={false}
                itemsDivided={false}
                itemsPerRow={3}
                linkAs={"none"}
                onlyEvenRows={true}
                showImage={true}
                verticalItemAlign={"center"}
              />
            </Grid.Column>
          </Grid>
          <Grid stackable className="component-section-container">
            <Grid.Column width={16}>
              <Contact
                phoneNumber={data.phone}
                address={{
                  street: data.address.street,
                  city: data.address.city,
                  state: data.address.state,
                  zip: data.address.zip
                }}
                hours={data.hours}
                as={"text"}
                buttonColor={"secondary"}
                header={"Contact"}
                image={""}
                showMap={true}
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    allFisherman {
      edges {
        node {
          ctas {
            orderOnline {
              link
              text
              internal
            }
            phone {
              link
              text
              internal
            }
          }
          heroImages {
            url
          }
          businessName
          galleryImages {
            url
          }
          reviews {
            name
            content
            link
          }
          phone
          address {
            street
            city
            state
            zip
          }
          hours {
            open
            close
            label
            day
          }
        }
      }
    }
    allFishermanImages {
      edges {
        node {
          heroImages {
            url
          }
          galleryImages {
            url
          }
        }
      }
    }
  }
`;
